import { saveAssetRecord } from './CorrelatorService';
const {  unmarshall } = require("@aws-sdk/util-dynamodb");

export default class SurveyDataService {
        
    // Saves the survey data to the server.
    put = async (data) => {
        var unmarshalled = unmarshall(data);
        //console.log(unmarshalled);
        const recSave = new Promise(function (resolve, reject) {
            saveAssetRecord(unmarshalled).then(res => res)
                .then((data) => {                   
                    return resolve(true);
                })
                .catch((error) => {
                    console.error(error);
                })

        });

        return recSave;
       
    };
}